<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0">
      <div class="title-text-official padding-b-19">佣金提现审核</div>
      <div class="search-wrap">
        <div class="search-form">
          <div class="search-item search-input-item">
            <input type="text" class="search-input"  v-model="searchForm.alipay" placeholder="支付宝账号"/>
          </div>
          <div class="search-item search-input-item search-box">
            <input type="text" class="search-input"  v-model="searchForm.withdrawMix" placeholder="提现金额"/>
            <span>至</span>
            <input type="text" class="search-input"  v-model="searchForm.withdrawMax" placeholder="提现金额"/>
          </div>
          <div class="search-item search-input-item search-box date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.start_time_bak" @blur.native @focus="showDatePicker('start_time_bak')" placeholder="提现时间" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.start_time_bak" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.start_time_bak')">
            </el-col>
            <el-col :span="2" class="date-range">至</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.end_time_bak" @blur.native @focus="showDatePicker('end_time_bak')" placeholder="提现时间" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.end_time_bak" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.end_time_bak')">
            </el-col>
          </div>
          <div class="search-item search-input-item">
            <Select v-model="searchForm.state" placeholder="提现状态">
              <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
        </div>
        <div class="search-btn" @click="handleFilter">查询</div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-0-15 padding-b-8">
      <div class="title-text-official padding-11-0 padding-b-19">列表</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="序号" width="50" align="center">
            <template slot-scope="{row}">
              <span>{{ row.sequence }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="微信名" width="100" align="center">
            <template slot-scope="{ row }">
              <div class="nickName">
                <img :src="row.headPic" /><span>{{row.nickName}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="真实姓名" width="80" align="center">
            <template slot-scope="{row}">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="支付宝账号" width="100" align="center">
            <template slot-scope="{row}">
              <span>{{ row.alipay }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="提现金额" width="80" align="center">
            <template slot-scope="{ row }">
              <span class="color-ff9" v-if="row.withdraw >= 0">￥{{row.withdraw}}</span>
              <span class="color-ff9" v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="提现时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="提现状态" width="80" align="center">
            <template slot-scope="{ row }">
              <span class="color-ff9" v-if="row.state == 0">待审核</span>
              <span class="color-666" v-if="row.state == 10">审核成功(待打款)</span>
              <span class="color-ff4" v-if="row.state == 20">审核驳回</span>
              <span class="color-666" v-if="row.state == 30">打款成功</span>
              <span class="color-ff4" v-if="row.state == 40">打款失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作" width="100" align="center">
            <template slot-scope="{ row }">
              <span class="color-41a" style="cursor: pointer;" v-if="row.state == 0" @click="audit(row.id)">仅审核不打款</span>
              <span class="color-ff4" style="cursor: pointer;" v-if="row.state == 0 || row.state == 10" @click="remit(row.id)">打款</span>
              <span class="color-ff4" style="cursor: pointer;" v-if="row.state == 0" @click="reject(row.id)">驳回</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="备注" width="80" align="center">
            <template slot-scope="{row}">
              <span>{{ row.remark }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.pageNo" :limit.sync="searchForm.pageSize" @pagination="getList(false)" />
      </div>
    </div>
    <Audit ref="Audit" @refreshList="getList(true)"></Audit>
    <Reject ref="Reject" @refreshList="getList(true)"></Reject>
    <DatePicker ref="DatePicker" :title="curDateTitle" @selectedDate="selectedDate"></DatePicker>
  </div>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import {  Select, Option } from 'view-design'
import DatePicker from '@/components/h5/DatePicker'
import Pagination from '@/components/h5/Pagination' // secondary package based on el-pagination
import { getDate } from '@/utils/date'
import Audit from '@/views/h5/official/commission/modal/Audit'
import Reject from '@/views/h5/official/commission/modal/Reject'
import commission from '@/javaApi/commission'
const commissionModel = new commission()
export default {
  name: 'Commission',
  components: {
    Pagination,
    DatePicker,
    Select,
    Option,
    Audit,
    Reject
  },
  data: function() {
    return {
      listLoading: false,
      status_list:[
        {"label":"全部","value":""},
        {"label":"待审核","value":"0"},
        {"label":"审核成功","value":"10"},
        {"label":"审核驳回","value":"20"},
        {"label":"打款成功","value":"30"},
        {"label":"打款失败","value":"40"}
      ],
      list: [],
      total: 0,
      platformUuid: getPlatformUuid(),
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        alipay: undefined,
        phone: undefined,
        withdrawMix: undefined,
        withdrawMax: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        state: undefined
      },
      curDateTitle: '',// 日期选择器弹窗标题
      datePicker: '', // 用于判断哪个选择器
    }
  },
  created() {
    this.getList(true)
  },
  methods: {
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        searchForm.platformUuid =  this.platformUuid
      }
      searchForm.createStartTime = getDate(searchForm.start_time_bak)
      searchForm.createEndTime = getDate(searchForm.end_time_bak)
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      searchForm = this.formateInit(searchForm)
      console.log(searchForm)
      if(searchForm.createStartTime){
        searchForm.createStartTime = searchForm.createStartTime+' 00:00:00'
      }
      if(searchForm.createEndTime){
        searchForm.createEndTime = searchForm.createEndTime+' 23:59:59'
      }
      commissionModel.getCommList(searchForm).then((response) => {
        var res = response.data
        this.listLoading = false
        if(res.code != 200){
          this.$Message.error(res.message)
          return
        }
        this.list = this.formateData(res.data.list)
        this.total = res.data.total
      })
    },
    formateData(data){
      if(!data){
        return []
      }
      if(!data.length){
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for(i=0;i<data.length;i++){
        data[i].sequence = (i+1)+(pageNo - 1)*pageSize
      }
      return  data
    },
    handleFilter() {
      this.getList(true)
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    //仅审核不打款
    audit(id){
      this.$refs.Audit.init(true,id,1)
    },
    //打款
    remit(id){
      this.$refs.Audit.init(true,id,2)
    },
    //驳回
    reject(id){
      this.$refs.Reject.init(true,id)
    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    showDatePicker(datePicker){
      let title = '请选择开始日期';
      if(datePicker.toUpperCase().indexOf('END') > -1){
        title = '请选择结束日期';
      }
      this.curDateTitle = title
      this.datePicker = datePicker
      this.$refs.DatePicker.init();
    },
    selectedDate(timer){
      this.searchForm[this.datePicker] = timer;
    },
    //清除文本框
    clear(val) {
      if(val.indexOf(".") > -1){
        let varArr = val.split(".")
        this[varArr[0]][varArr[1]] = ''
      }else{
        this[val] = ''
      }
    },
  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  font-family: Alibaba-PuHuiTi-R;
  .table-wrapper {
    width: 100%;
    .color-ff4{
      white-space: nowrap;
      line-height: 1.5;
    }
    .nickName{
      img{
        width: 20px;
        margin-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/commission/Index.vue